import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GState } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, XButton, XText } from "IZOX/_X";
import _ from "lodash";
import { LocaleConfig } from "__SYSDefault/Locale";

/**
 * @augments {Component<Props, State>}
 */
class LangSW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(LangSW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toggleLang = () => {
    GState.setLang(GState.lang === "EN" ? "TC" : "EN");
  }

  renderLangBox = (code) => {
    let {widen} = this.props;
    let isLang = GState.lang === code;
    let config = _.find(LocaleConfig, o => o.code === code);
    
    let _width = widen ? 60 : 32;
    let _height = widen ? 40 : 32;

    return (
      <HStack width={_width} height={_height} pH={6} pV={4} round={6}
        bgColor={ColorX.CSS(isLang ? "DeepBlueSea" : "pureWhite")}>
        <XText color={ColorX.CSS(isLang ? "pureWhite" : "Gray4")} fontSize={14}>
          {config.caption}
        </XText>
      </HStack>
    );
  }

  render(){
    let {widen} = this.props;
    let _height = widen ? 40 : 32;

    return (
      <XButton onPress={this._toggleLang} 
        padding={1} delayAfterPress={1}>
        <HStack round={11} 
          bgColor={ColorX.CSS("DeepBlueSea")}
          bW={2}
          bColor={ColorX.CSS("DeepBlueSea")}>
          <HStack style={{position: "absolute", top: 0, zIndex: 1}} p={3}>
            <HStack width={10} bgColor={ColorX.CSS("pureWhite")} height={_height}/>
          </HStack>
          <HStack style={{zIndex: 2}}>
            {this.renderLangBox("EN")}
            {this.renderLangBox("TC")}
          </HStack>
        </HStack>
      </XButton>
    );
  }
}

export default observer(LangSW);
